/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 15/09/25
 */

import React, { useEffect } from 'react';
import LeaveTile from '@/components/pages/dashboard/tiles/LeaveTile/LeaveTile';
import { useGetRequest } from '@/utils/useStatefulRequests';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';

const LeaveSummary = ({ year }: { year: number }) => {
    const { currentAssignment } = useAssignment();

    const { makeRequest, responseData, loading, error } = useGetRequest<{ annual: number; other: number }>();

    useEffect(() => {
        if (currentAssignment) makeRequest(`/leave/balances/${year}`, { params: { assignment: currentAssignment.id } });
    }, [year, currentAssignment]);

    return (
        <LeaveTile
            values={
                responseData
                    ? {
                          plannedOtherLeaveDays: 0,
                          plannedAnnualDays: 0,
                          bookedAnnualLeaveDays: responseData.annual,
                          bookedOtherLeaveDays: responseData.other,
                      }
                    : undefined
            }
            loading={loading}
            error={!!error}
        />
    );
};

export default LeaveSummary;
